// extracted by mini-css-extract-plugin
export var root = "text-module--root--eeca0";